/**
 * Investigator Scriptures Data - Spanish (ES)
 * PME+ Support Scriptures included
 */

import type { Scripture } from './scriptures';

export const scripturesEs: Scripture[] = [
  // ===============================
  // EXISTING SCRIPTURES
  // ===============================
  {
    id: '1-john-3-1',
    reference: '1 Juan 3:1',
    text: 'Mirad cuál amor nos ha dado el Padre, para que seamos llamados hijos de Dios.',
    verses: [{ verse: 1, text: 'Mirad cuál amor nos ha dado el Padre, para que seamos llamados hijos de Dios.' }],
    context: 'El apóstol Juan enseña que ser llamado "hijo de Dios" no es simbólico, sino una realidad espiritual que define quiénes somos y hacia dónde vamos.',
  },
  {
    id: 'john-14-26',
    reference: 'Juan 14:26',
    text: 'Mas el Consolador, el Espíritu Santo, a quien el Padre enviará en mi nombre, él os enseñará todas las cosas, y os recordará todo lo que yo os he dicho.',
    verses: [
      {
        verse: 26,
        text: 'Mas el Consolador, el Espíritu Santo, a quien el Padre enviará en mi nombre, él os enseñará todas las cosas, y os recordará todo lo que yo os he dicho.',
      },
    ],
    context: 'Jesucristo prometió a Sus discípulos que, aun cuando Él ya no estuviera físicamente con ellos, el Espíritu Santo continuaría guiándolos y enseñándolos.',
  },
  {
    id: 'matthew-7-7',
    reference: 'Mateo 7:7',
    text: 'Pedid, y se os dará; buscad, y hallaréis; llamad, y se os abrirá.',
    verses: [{ verse: 7, text: 'Pedid, y se os dará; buscad, y hallaréis; llamad, y se os abrirá.' }],
    context: 'Jesucristo enseñó que Dios no es indiferente a nuestras peticiones. Él responde, aunque no siempre de la manera o en el tiempo que esperamos.',
  },
  {
    id: 'john-3-16',
    reference: 'Juan 3:16',
    text: 'Porque de tal manera amó Dios al mundo, que ha dado a su Hijo unigénito, para que todo aquel que en él cree, no se pierda, mas tenga vida eterna.',
    context: 'Estas palabras enseñan que el sacrificio de Jesucristo es una expresión del amor infinito del Padre por cada uno de Sus hijos, sin excepción.',
  },
  {
    id: 'james-1-5',
    reference: 'Santiago 1:5',
    text: 'Y si alguno de vosotros tiene falta de sabiduría, pídala a Dios, el cual da a todos abundantemente y sin reproche, y le será dada.',
    verses: [
      {
        verse: 5,
        text: 'Y si alguno de vosotros tiene falta de sabiduría, pídala a Dios, el cual da a todos abundantemente y sin reproche, y le será dada.',
      },
    ],
    context: 'Santiago enseña sobre buscar sabiduría de Dios. Esta escritura inspiró a José Smith a orar y recibir la Primera Visión.',
  },
  {
    id: 'moroni-10-4',
    reference: 'Moroni 10:4',
    text: 'Y cuando recibáis estas cosas, quisiera exhortaros a que preguntéis a Dios, el Eterno Padre, en el nombre de Cristo, si estas cosas no son verdaderas.',
    verses: [{ verse: 4, text: 'Y cuando recibáis estas cosas, quisiera exhortaros a que preguntéis a Dios, el Eterno Padre, en el nombre de Cristo, si estas cosas no son verdaderas.' }],
    context: 'Moroni, el último profeta del Libro de Mormón, invita a los lectores a buscar confirmación directa de Dios con un corazón sincero.',
  },
  {
    id: 'moroni-10-5',
    reference: 'Moroni 10:5',
    text: 'Y por el poder del Espíritu Santo podréis conocer la verdad de todas las cosas.',
    verses: [{ verse: 5, text: 'Y por el poder del Espíritu Santo podréis conocer la verdad de todas las cosas.' }],
    context: 'El profeta Moroni invita a todos los lectores a preguntar directamente a Dios si el Libro de Mormón es verdadero, prometiendo una respuesta espiritual personal.',
  },
  {
    id: 'moroni-10-4-5',
    reference: 'Moroni 10:4–5',
    text: 'Y cuando recibáis estas cosas, quisiera exhortaros a que preguntéis a Dios, el Eterno Padre, en el nombre de Cristo, si estas cosas no son verdaderas; y si pedís con un corazón sincero, con verdadera intención, teniendo fe en Cristo, él os manifestará la verdad de ellas por el poder del Espíritu Santo. Y por el poder del Espíritu Santo podréis conocer la verdad de todas las cosas.',
    verses: [
      { verse: 4, text: 'Y cuando recibáis estas cosas, quisiera exhortaros a que preguntéis a Dios, el Eterno Padre, en el nombre de Cristo, si estas cosas no son verdaderas; y si pedís con un corazón sincero, con verdadera intención, teniendo fe en Cristo, él os manifestará la verdad de ellas por el poder del Espíritu Santo.' },
      { verse: 5, text: 'Y por el poder del Espíritu Santo podréis conocer la verdad de todas las cosas.' },
    ],
    context: 'Moroni enseña un patrón claro: leer, meditar en la misericordia de Dios, orar con verdadera intención y recibir una respuesta por el Espíritu Santo.',
  },
  {
    id: 'moroni-10-3-5',
    reference: 'Moroni 10:3–5',
    text: 'He aquí, quisiera exhortaros a que cuando hayáis leído estas cosas, si es sabiduría en Dios que las leáis, que os acordéis de cuán misericordioso ha sido el Señor con los hijos de los hombres, desde la creación de Adán hasta el momento en que recibáis estas cosas, y que lo meditéis en vuestros corazones. Y cuando recibáis estas cosas, quisiera exhortaros a que preguntéis a Dios, el Eterno Padre, en el nombre de Cristo, si estas cosas no son verdaderas; y si pedís con un corazón sincero, con verdadera intención, teniendo fe en Cristo, él os manifestará la verdad de ellas por el poder del Espíritu Santo. Y por el poder del Espíritu Santo podréis conocer la verdad de todas las cosas.',
    verses: [
      { verse: 3, text: 'He aquí, quisiera exhortaros a que cuando hayáis leído estas cosas, si es sabiduría en Dios que las leáis, que os acordéis de cuán misericordioso ha sido el Señor con los hijos de los hombres, desde la creación de Adán hasta el momento en que recibáis estas cosas, y que lo meditéis en vuestros corazones.' },
      { verse: 4, text: 'Y cuando recibáis estas cosas, quisiera exhortaros a que preguntéis a Dios, el Eterno Padre, en el nombre de Cristo, si estas cosas no son verdaderas; y si pedís con un corazón sincero, con verdadera intención, teniendo fe en Cristo, él os manifestará la verdad de ellas por el poder del Espíritu Santo.' },
      { verse: 5, text: 'Y por el poder del Espíritu Santo podréis conocer la verdad de todas las cosas.' },
    ],
    context: 'Moroni enseña un patrón claro: leer, recordar la misericordia de Dios, meditar, orar con verdadera intención y recibir una respuesta por el Espíritu Santo.',
  },
  {
    id: 'john-14-6',
    reference: 'Juan 14:6',
    text: 'Jesús le dijo: Yo soy el camino, y la verdad, y la vida; nadie viene al Padre, sino por mí.',
    context: 'Jesús enseña que Él es el único camino hacia el Padre.',
  },
  {
    id: 'alma-37-37',
    reference: 'Alma 37:37',
    text: 'Consulta al Señor en todos tus hechos, y Él te llevará para bien.',
    verses: [{ verse: 37, text: 'Consulta al Señor en todos tus hechos, y Él te llevará para bien.' }],
    context: 'La oración no es solo para los problemas grandes; también es para las decisiones pequeñas de cada día.',
  },
  {
    id: 'alma-32-21',
    reference: 'Alma 32:21',
    text: 'La fe no es tener un conocimiento perfecto de las cosas; por tanto, si tenéis fe, tenéis esperanza en cosas que no se ven, pero que son verdaderas.',
    context: 'Alma enseñó que la fe comienza como un deseo y crece cuando se nutre con acción constante y sincera.',
  },
  {
    id: 'matthew-11-28',
    reference: 'Mateo 11:28',
    text: 'Venid a mí todos los que estáis trabajados y cargados, y yo os haré descansar.',
    verses: [
      {
        verse: 28,
        text: 'Venid a mí todos los que estáis trabajados y cargados, y yo os haré descansar.',
      },
    ],
    context: 'Jesucristo invita a quienes se sienten agobiados por el pecado, el error o la carga emocional a acudir a Él para encontrar descanso y renovación espiritual.',
  },
  {
    id: 'mark-16-16',
    reference: 'Marcos 16:16',
    text: 'El que creyere y fuere bautizado, será salvo; mas el que no creyere, será condenado.',
    context: 'Jesucristo enseñó que el bautismo va unido a la fe y a la disposición de seguirlo, no a la imposición ni a la presión.',
  },
  {
    id: 'acts-8-17',
    reference: 'Hechos 8:17',
    text: 'Y después que fueron bautizados, les impusieron las manos, y recibieron el Espíritu Santo.',
    verses: [
      {
        verse: 17,
        text: 'Y después que fueron bautizados, les impusieron las manos, y recibieron el Espíritu Santo.',
      },
    ],
    context: 'En la Iglesia primitiva, los apóstoles seguían este mismo patrón: bautismo seguido de la imposición de manos para conferir el don del Espíritu Santo.',
  },
  {
    id: 'dc-20-77',
    reference: 'Doctrina y Convenios 20:77',
    text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén.',
    verses: [
      {
        verse: 77,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén.',
      },
    ],
    context: 'Esta escritura forma parte de la oración sacramental y establece claramente la promesa divina asociada a la Santa Cena.',
  },
  {
    id: 'john-14-15',
    reference: 'Juan 14:15',
    text: 'Si me amáis, guardad mis mandamientos.',
    verses: [{ verse: 15, text: 'Si me amáis, guardad mis mandamientos.' }],
    context: 'Jesucristo enseñó que la obediencia no nace del miedo, sino del amor y de la relación personal con Él.',
  },
  {
    id: 'ephesians-4-11',
    reference: 'Efesios 4:11',
    text: 'Y él mismo constituyó a unos, apóstoles; a otros, profetas; a otros, evangelistas; a otros, pastores y maestros.',
    verses: [
      {
        verse: 11,
        text: 'Y él mismo constituyó a unos, apóstoles; a otros, profetas; a otros, evangelistas; a otros, pastores y maestros.',
      },
    ],
    context: 'El apóstol Pablo enseña que Jesucristo organizó Su Iglesia con líderes y funciones específicas para edificar y cuidar a los santos.',
  },
  {
    id: 'jeremiah-1-5',
    reference: 'Jeremías 1:5',
    text: 'Antes que te formase en el vientre te conocí, y antes que nacieses te santifiqué, te di por profeta a las naciones.',
    verses: [{ verse: 5, text: 'Antes que te formase en el vientre te conocí, y antes que nacieses te santifiqué, te di por profeta a las naciones.' }],
    context: 'Dios nos conoció antes de nacer. Esta escritura enseña la realidad de la vida premortal y la preordenación divina.',
  },
  {
    id: 'jeremiah-31-22',
    reference: 'Jeremías 31:22',
    text: 'He aquí que vienen días, dice Jehová, en los cuales haré nueva cosa en la tierra.',
    context: 'Los profetas del Antiguo Testamento anunciaron que Dios haría algo nuevo en los últimos días, preparando el camino para una restauración futura.',
  },
  {
    id: 'js-history-1-17',
    reference: 'José Smith—Historia 1:17',
    text: 'Este es mi Hijo Amado. ¡Escúchalo!',
    context: 'Estas palabras fueron pronunciadas por Dios Padre al presentar a Jesucristo durante la Primera Visión, revelando que ambos son seres distintos y reales.',
  },
  {
    id: 'amos-3-7',
    reference: 'Amós 3:7',
    text: 'Ciertamente Jehová el Señor no hará nada sin revelar su secreto a sus siervos los profetas.',
    context: 'El profeta Amós enseña que Dios actúa de manera ordenada y comunica Su voluntad antes de realizar grandes obras entre Su pueblo.',
  },
  {
    id: 'hebrews-5-4',
    reference: 'Hebreos 5:4',
    text: 'Y nadie toma para sí esta honra, sino el que es llamado por Dios, como lo fue Aarón.',
    verses: [
      {
        verse: 4,
        text: 'Y nadie toma para sí esta honra, sino el que es llamado por Dios, como lo fue Aarón.',
      },
    ],
    context: 'El apóstol Pablo enseña que el sacerdocio no se asume por iniciativa propia, sino que se recibe por llamamiento y ordenación divina.',
  },
  {
    id: 'moses-1-39',
    reference: 'Moisés 1:39',
    text: 'Porque he aquí, esta es mi obra y mi gloria: llevar a cabo la inmortalidad y la vida eterna del hombre.',
    context: 'Dios declara que todo Su plan gira en torno al bienestar eterno de Sus hijos.',
  },
  {
    id: 'genesis-3-6-7',
    reference: 'Génesis 3:6–7',
    text: 'Y vio la mujer que el árbol era bueno para comer, y que era agradable a los ojos, y árbol codiciable para alcanzar la sabiduría; y tomó de su fruto y comió; y dio también a su marido, el cual comió así como ella. Entonces fueron abiertos los ojos de ambos, y conocieron que estaban desnudos; entonces cosieron hojas de higuera y se hicieron delantales.',
    verses: [
      { verse: 6, text: 'Y vio la mujer que el árbol era bueno para comer, y que era agradable a los ojos, y árbol codiciable para alcanzar la sabiduría; y tomó de su fruto y comió; y dio también a su marido, el cual comió así como ella.' },
      { verse: 7, text: 'Entonces fueron abiertos los ojos de ambos, y conocieron que estaban desnudos; entonces cosieron hojas de higuera y se hicieron delantales.' },
    ],
    context: 'La Caída abrió el camino para la experiencia mortal, el albedrío y la necesidad de un Salvador.',
  },
  {
    id: 'exodus-20-8-11',
    reference: 'Éxodo 20:8–11',
    text: 'Acuérdate del día de reposo para santificarlo. Seis días trabajarás y harás toda tu obra; mas el séptimo día es reposo para Jehová tu Dios; no hagas en él obra alguna, tú, ni tu hijo, ni tu hija, ni tu siervo, ni tu criada, ni tu bestia, ni tu extranjero que está dentro de tus puertas. Porque en seis días hizo Jehová los cielos y la tierra, el mar y todas las cosas que en ellos hay, y reposó en el séptimo día; por tanto, Jehová bendijo el día de reposo y lo santificó.',
    verses: [
      { verse: 8, text: 'Acuérdate del día de reposo para santificarlo.' },
      { verse: 9, text: 'Seis días trabajarás y harás toda tu obra;' },
      { verse: 10, text: 'mas el séptimo día es reposo para Jehová tu Dios; no hagas en él obra alguna, tú, ni tu hijo, ni tu hija, ni tu siervo, ni tu criada, ni tu bestia, ni tu extranjero que está dentro de tus puertas.' },
      { verse: 11, text: 'Porque en seis días hizo Jehová los cielos y la tierra, el mar y todas las cosas que en ellos hay, y reposó en el séptimo día; por tanto, Jehová bendijo el día de reposo y lo santificó.' },
    ],
    context: 'Dios manda a Su pueblo guardar el día de reposo santo como día de descanso y adoración.',
  },
  {
    id: 'matthew-19-6',
    reference: 'Mateo 19:6',
    text: 'Así que no son ya más dos, sino una sola carne; por tanto, lo que Dios juntó, no lo separe el hombre.',
    verses: [
      {
        verse: 6,
        text: 'Así que no son ya más dos, sino una sola carne; por tanto, lo que Dios juntó, no lo separe el hombre.',
      },
    ],
    context: 'Jesucristo enseña que el matrimonio es una unión sagrada establecida por Dios.',
  },
  {
    id: 'john-14-2',
    reference: 'Juan 14:2',
    text: 'En la casa de mi Padre muchas moradas hay; si así no fuera, yo os lo hubiera dicho; voy, pues, a preparar lugar para vosotros.',
    verses: [
      {
        verse: 2,
        text: 'En la casa de mi Padre muchas moradas hay; si así no fuera, yo os lo hubiera dicho; voy, pues, a preparar lugar para vosotros.',
      },
    ],
    context: 'Jesucristo enseña que el cielo no es uniforme, sino preparado para cada persona.',
  },
  {
    id: 'malachi-3-10',
    reference: 'Malaquías 3:10',
    text: 'Traed todos los diezmos al alfolí y haya alimento en mi casa; y probadme ahora en esto, dice Jehová de los ejércitos, si no os abriré las ventanas de los cielos y derramaré sobre vosotros bendición hasta que sobreabunde.',
    verses: [
      {
        verse: 10,
        text: 'Traed todos los diezmos al alfolí y haya alimento en mi casa; y probadme ahora en esto, dice Jehová de los ejércitos, si no os abriré las ventanas de los cielos y derramaré sobre vosotros bendición hasta que sobreabunde.',
      },
    ],
    context: 'Dios invita a Su pueblo a confiar en Él mediante el diezmo, prometiendo bendiciones reales y recordando que la obediencia puede probarse con fe, no con presión.',
  },
  {
    id: 'matthew-6-21',
    reference: 'Mateo 6:21',
    text: 'Porque donde esté vuestro tesoro, allí estará también vuestro corazón.',
    verses: [
      {
        verse: 21,
        text: 'Porque donde esté vuestro tesoro, allí estará también vuestro corazón.',
      },
    ],
    context: 'Jesucristo enseña que nuestras prioridades reales se revelan por aquello a lo que dedicamos nuestros recursos, atención y confianza.',
  },
  {
    id: 'matthew-6-9',
    reference: 'Mateo 6:9',
    text: 'De esta manera, pues, orad vosotros: Padre nuestro que estás en los cielos, santificado sea tu nombre.',
    verses: [
      {
        verse: 9,
        text: 'De esta manera, pues, orad vosotros: Padre nuestro que estás en los cielos, santificado sea tu nombre.',
      },
    ],
    context: 'Jesucristo enseña a Sus discípulos cómo orar, comenzando dirigiéndose a Dios como Padre en los cielos.',
  },
  {
    id: '1-corinthians-6-19-20',
    reference: '1 Corintios 6:19–20',
    text: '¿O ignoráis que vuestro cuerpo es templo del Espíritu Santo, el cual está en vosotros, el cual tenéis de Dios, y que no sois vuestros? Porque habéis sido comprados por precio; glorificad, pues, a Dios en vuestro cuerpo y en vuestro espíritu, los cuales son de Dios.',
    verses: [
      {
        verse: 19,
        text: '¿O ignoráis que vuestro cuerpo es templo del Espíritu Santo, el cual está en vosotros, el cual tenéis de Dios, y que no sois vuestros?',
      },
      {
        verse: 20,
        text: 'Porque habéis sido comprados por precio; glorificad, pues, a Dios en vuestro cuerpo y en vuestro espíritu, los cuales son de Dios.',
      },
    ],
    context: 'Pablo enseña la dignidad sagrada del cuerpo y la responsabilidad espiritual de honrar a Dios con nuestras decisiones.',
  },
  {
    id: 'dc-89-18-21',
    reference: 'Doctrina y Convenios 89:18–21',
    text: 'Y todos los santos que se acuerden de guardar y hacer estas palabras, andando en obediencia a los mandamientos, recibirán salud en su ombligo y médula en sus huesos; y hallarán sabiduría y grandes tesoros de conocimiento, sí, tesoros escondidos; y correrán y no se fatigarán, y andarán y no desmayarán; y el ángel destructor pasará de ellos, como de los hijos de Israel, y no los matará.',
    context: 'El Señor promete bendiciones de salud, claridad y protección a quienes procuran vivir con obediencia y dominio propio.',
  },

  // ===============================
  // PME+ SUPPORT SCRIPTURES (NEW)
  // ===============================
  {
    id: '2-thessalonians-2-3',
    reference: '2 Tesalonicenses 2:3',
    text: 'Nadie os engañe en ninguna manera; porque no vendrá sin que antes venga la apostasía, y se manifieste el hombre de pecado, el hijo de perdición.',
    verses: [
      { verse: 3, text: 'Nadie os engañe en ninguna manera; porque no vendrá sin que antes venga la apostasía, y se manifieste el hombre de pecado, el hijo de perdición.' },
    ],
    context:
      'Pablo advierte que habría un apartamiento (apostasía). Esta idea ayuda a entender por qué sería necesaria una restauración posterior de la verdad y la autoridad.',
  },
  {
    id: 'acts-3-19-21',
    reference: 'Hechos 3:19–21',
    text: 'Así que, arrepentíos y convertíos, para que sean borrados vuestros pecados; para que vengan de la presencia del Señor tiempos de refrigerio, y él envíe a Jesucristo, que os fue antes anunciado; a quien de cierto es necesario que el cielo reciba hasta los tiempos de la restauración de todas las cosas, de que habló Dios por boca de sus santos profetas que han sido desde tiempo antiguo.',
    verses: [
      { verse: 19, text: 'Así que, arrepentíos y convertíos, para que sean borrados vuestros pecados; para que vengan de la presencia del Señor tiempos de refrigerio,' },
      { verse: 20, text: 'y él envíe a Jesucristo, que os fue antes anunciado;' },
      { verse: 21, text: 'a quien de cierto es necesario que el cielo reciba hasta los tiempos de la restauración de todas las cosas, de que habló Dios por boca de sus santos profetas que han sido desde tiempo antiguo.' },
    ],
    context:
      'Pedro enseña que habría "restauración de todas las cosas", conectando la fe cristiana primitiva con la expectativa profética de una restauración futura.',
  },
  {
    id: 'dc-58-42-43',
    reference: 'Doctrina y Convenios 58:42–43',
    text: 'He aquí, el que se ha arrepentido de sus pecados es perdonado; y yo, el Señor, no los recuerdo más. Por esto podréis saber si un hombre se arrepiente de sus pecados—he aquí, los confesará y los abandonará.',
    verses: [
      { verse: 42, text: 'He aquí, el que se ha arrepentido de sus pecados es perdonado; y yo, el Señor, no los recuerdo más.' },
      { verse: 43, text: 'Por esto podréis saber si un hombre se arrepiente de sus pecados—he aquí, los confesará y los abandonará.' },
    ],
    context:
      'El Señor define el arrepentimiento como un cambio real: reconocer, confesar cuando corresponde y abandonar el pecado. No es castigo; es regreso a Dios.',
  },
  {
    id: '2-nephi-2-25-27',
    reference: '2 Nefi 2:25–27',
    text: 'Adán cayó para que los hombres existieran; y los hombres existen para que tengan gozo. Y el Mesías vendrá en el cumplimiento de los tiempos, para redimir a los hijos de los hombres del pecado. Y porque son redimidos del pecado se han vuelto libres para siempre, conociendo el bien del mal; para actuar por sí mismos y no para que se actúe sobre ellos, a menos que sea por el castigo de la ley en el grande y postrer día, según los mandamientos que Dios ha dado. Y los hombres son libres según la carne; y todas las cosas les son dadas que les son útiles. Y son libres para escoger la libertad y la vida eterna, por medio del gran Mediador de todos los hombres, o escoger la cautividad y la muerte, según la cautividad y el poder del diablo; porque él busca que todos los hombres sean miserables como él.',
    verses: [
      { verse: 25, text: 'Adán cayó para que los hombres existieran; y los hombres existen para que tengan gozo.' },
      { verse: 26, text: 'Y el Mesías vendrá en el cumplimiento de los tiempos, para redimir a los hijos de los hombres del pecado. Y porque son redimidos del pecado se han vuelto libres para siempre, conociendo el bien del mal; para actuar por sí mismos y no para que se actúe sobre ellos, a menos que sea por el castigo de la ley en el grande y postrer día, según los mandamientos que Dios ha dado.' },
      { verse: 27, text: 'Y los hombres son libres según la carne; y todas las cosas les son dadas que les son útiles. Y son libres para escoger la libertad y la vida eterna, por medio del gran Mediador de todos los hombres, o escoger la cautividad y la muerte, según la cautividad y el poder del diablo; porque él busca que todos los hombres sean miserables como él.' },
    ],
    context:
      'Lehi enseña el propósito de la mortalidad: gozo, albedrío y elecciones con consecuencias eternas. Explica por qué la vida incluye oposición y pruebas.',
  },
  {
    id: '2-nephi-31-20',
    reference: '2 Nefi 31:20',
    text: 'Por tanto, debéis seguir adelante con firmeza en Cristo, teniendo un fulgor perfecto de esperanza y amor por Dios y por todos los hombres. Por tanto, si avanzáis haciendo fiesta de la palabra de Cristo y perseveráis hasta el fin, he aquí, así dice el Padre: Tendréis la vida eterna.',
    verses: [{ verse: 20, text: 'Por tanto, debéis seguir adelante con firmeza en Cristo, teniendo un fulgor perfecto de esperanza y amor por Dios y por todos los hombres. Por tanto, si avanzáis haciendo fiesta de la palabra de Cristo y perseveráis hasta el fin, he aquí, así dice el Padre: Tendréis la vida eterna.' }],
    context:
      'Nefi enseña que el discipulado verdadero es constancia y esperanza. El Evangelio no es un evento; es un camino sostenido en Cristo.',
  },
  {
    id: 'matthew-3-13-17',
    reference: 'Mateo 3:13–17',
    text: 'Entonces vino Jesús de Galilea al Jordán, a Juan, para ser bautizado por él. Mas Juan se le oponía, diciendo: Yo necesito ser bautizado por ti, ¿y tú vienes a mí? Respondiendo Jesús, le dijo: Déjalo ahora, porque así conviene que cumplamos toda justicia. Entonces le dejó. Y Jesús, después que fue bautizado, subió inmediatamente del agua; y he aquí, los cielos se abrieron, y vio al Espíritu de Dios que descendía como paloma y venía sobre él. Y he aquí, una voz de los cielos que decía: Este es mi Hijo Amado, en quien tengo complacencia.',
    verses: [
      { verse: 13, text: 'Entonces vino Jesús de Galilea al Jordán, a Juan, para ser bautizado por él.' },
      { verse: 14, text: 'Mas Juan se le oponía, diciendo: Yo necesito ser bautizado por ti, ¿y tú vienes a mí?' },
      { verse: 15, text: 'Respondiendo Jesús, le dijo: Déjalo ahora, porque así conviene que cumplamos toda justicia. Entonces le dejó.' },
      { verse: 16, text: 'Y Jesús, después que fue bautizado, subió inmediatamente del agua; y he aquí, los cielos se abrieron, y vio al Espíritu de Dios que descendía como paloma y venía sobre él.' },
      { verse: 17, text: 'Y he aquí, una voz de los cielos que decía: Este es mi Hijo Amado, en quien tengo complacencia.' },
    ],
    context: 'Jesús fue bautizado por Juan el Bautista en el río Jordán, cumpliendo toda justicia. El Espíritu Santo descendió sobre Él y el Padre dio testimonio de Su Hijo.',
  },
  {
    id: 'acts-2-38',
    reference: 'Hechos 2:38',
    text: 'Pedro les dijo: Arrepentíos, y bautícese cada uno de vosotros en el nombre de Jesucristo para perdón de los pecados; y recibiréis el don del Espíritu Santo.',
    verses: [{ verse: 38, text: 'Pedro les dijo: Arrepentíos, y bautícese cada uno de vosotros en el nombre de Jesucristo para perdón de los pecados; y recibiréis el don del Espíritu Santo.' }],
    context: 'Pedro enseña que el arrepentimiento y el bautismo en el nombre de Jesucristo conducen al perdón de los pecados y al don del Espíritu Santo.',
  },
  {
    id: '2-nephi-31-5-12',
    reference: '2 Nefi 31:5–12',
    text: 'Ahora bien, si el Cordero de Dios, que es santo, tiene necesidad de ser bautizado en el agua para cumplir con toda justicia, ¡cuánto mayor es, entonces, la necesidad que tenemos nosotros, siendo impuros, de ser bautizados, sí, en el agua! Y ahora, quisiera preguntaros, amados hermanos míos, ¿cómo cumplió el Cordero de Dios con toda justicia bautizándose en el agua? ¿No sabéis que era santo? Mas no obstante que era santo, él muestra a los hijos de los hombres que, según la carne, él se humilla ante el Padre, y testifica al Padre que le sería obediente al observar sus mandamientos. Por tanto, después que fue bautizado con agua, el Espíritu Santo descendió sobre él en forma de paloma. Y además, esto muestra a los hijos de los hombres la angostura de la senda, y la estrechez de la puerta por la cual ellos deben entrar, habiéndoles él puesto el ejemplo por delante. Y dijo a los hijos de los hombres: Seguidme. Por tanto, mis amados hermanos, ¿podemos seguir a Jesús, a menos que estemos dispuestos a guardar los mandamientos del Padre? Y el Padre dijo: Arrepentíos, arrepentíos y sed bautizados en el nombre de mi Amado Hijo. Y además, vino a mí la voz del Hijo, diciendo: A quien se bautice en mi nombre, el Padre dará el Espíritu Santo, como a mí; por tanto, seguidme y haced las cosas que me habéis visto hacer.',
    verses: [
      { verse: 5, text: 'Ahora bien, si el Cordero de Dios, que es santo, tiene necesidad de ser bautizado en el agua para cumplir con toda justicia, ¡cuánto mayor es, entonces, la necesidad que tenemos nosotros, siendo impuros, de ser bautizados, sí, en el agua!' },
      { verse: 6, text: 'Y ahora, quisiera preguntaros, amados hermanos míos, ¿cómo cumplió el Cordero de Dios con toda justicia bautizándose en el agua?' },
      { verse: 7, text: '¿No sabéis que era santo? Mas no obstante que era santo, él muestra a los hijos de los hombres que, según la carne, él se humilla ante el Padre, y testifica al Padre que le sería obediente al observar sus mandamientos.' },
      { verse: 8, text: 'Por tanto, después que fue bautizado con agua, el Espíritu Santo descendió sobre él en forma de paloma.' },
      { verse: 9, text: 'Y además, esto muestra a los hijos de los hombres la angostura de la senda, y la estrechez de la puerta por la cual ellos deben entrar, habiéndoles él puesto el ejemplo por delante.' },
      { verse: 10, text: 'Y dijo a los hijos de los hombres: Seguidme. Por tanto, mis amados hermanos, ¿podemos seguir a Jesús, a menos que estemos dispuestos a guardar los mandamientos del Padre?' },
      { verse: 11, text: 'Y el Padre dijo: Arrepentíos, arrepentíos y sed bautizados en el nombre de mi Amado Hijo.' },
      { verse: 12, text: 'Y además, vino a mí la voz del Hijo, diciendo: A quien se bautice en mi nombre, el Padre dará el Espíritu Santo, como a mí; por tanto, seguidme y haced las cosas que me habéis visto hacer.' },
    ],
    context: 'Nefi enseña la doctrina de Cristo: el bautismo como ejemplo del Salvador, la humildad ante el Padre y la promesa del Espíritu Santo.',
  },
  {
    id: 'dc-20-37',
    reference: 'Doctrina y Convenios 20:37',
    text: 'Además, por vía de mandamiento a la iglesia concerniente a la manera del bautismo: Todos los que se humillen ante Dios, y deseen bautizarse, y vengan con corazones quebrantados y con espíritus contritos, y testifiquen ante la iglesia que se han arrepentido verdaderamente de todos sus pecados, y que están dispuestos a tomar sobre sí el nombre de Jesucristo, con la determinación de servirle hasta el fin, y verdaderamente manifiesten por sus obras que han recibido del Espíritu de Cristo para la remisión de sus pecados, serán recibidos en su iglesia por el bautismo.',
    verses: [{ verse: 37, text: 'Además, por vía de mandamiento a la iglesia concerniente a la manera del bautismo: Todos los que se humillen ante Dios, y deseen bautizarse, y vengan con corazones quebrantados y con espíritus contritos, y testifiquen ante la iglesia que se han arrepentido verdaderamente de todos sus pecados, y que están dispuestos a tomar sobre sí el nombre de Jesucristo, con la determinación de servirle hasta el fin, y verdaderamente manifiesten por sus obras que han recibido del Espíritu de Cristo para la remisión de sus pecados, serán recibidos en su iglesia por el bautismo.' }],
    context: 'El Señor establece los requisitos para el bautismo: humildad, arrepentimiento, disposición de tomar el nombre de Cristo y servirle hasta el fin.',
  },
  {
    id: 'john-3-5',
    reference: 'Juan 3:5',
    text: 'El que no naciere de agua y del Espíritu, no puede entrar en el reino de Dios.',
    verses: [{ verse: 5, text: 'El que no naciere de agua y del Espíritu, no puede entrar en el reino de Dios.' }],
    context:
      'Jesucristo enseña la necesidad de ordenanzas (agua y Espíritu). Esto refuerza la doctrina de bautismo y confirmación como pasos esenciales del Evangelio.',
  },
  {
    id: 'romans-6-4',
    reference: 'Romanos 6:4',
    text: 'Porque somos sepultados juntamente con él para muerte por el bautismo, a fin de que como Cristo resucitó de los muertos por la gloria del Padre, así también nosotros andemos en vida nueva.',
    context:
      'Pablo explica el simbolismo del bautismo: sepultura y resurrección a una vida nueva. Refuerza la importancia de la inmersión.',
  },
  {
    id: 'mosiah-18-8-9',
    reference: 'Mosíah 18:8–9',
    text: 'Y aconteció que les dijo: He aquí las aguas de Mormón (porque así se llamaban); y ya que deseáis entrar en el redil de Dios y ser llamados su pueblo, y estáis dispuestos a llevar las cargas los unos de los otros para que sean ligeras; sí, y estáis dispuestos a llorar con los que lloran; sí, y a consolar a los que necesitan de consuelo, y ser testigos de Dios en todo tiempo, y en todas las cosas y en todo lugar en que estuvieseis, aun hasta la muerte, para que seáis redimidos por Dios, y seáis contados con los de la primera resurrección, para que tengáis vida eterna;',
    verses: [
      {
        verse: 8,
        text: 'Y aconteció que les dijo: He aquí las aguas de Mormón (porque así se llamaban); y ya que deseáis entrar en el redil de Dios y ser llamados su pueblo, y estáis dispuestos a llevar las cargas los unos de los otros para que sean ligeras;',
      },
      {
        verse: 9,
        text: 'sí, y estáis dispuestos a llorar con los que lloran; sí, y a consolar a los que necesitan de consuelo, y ser testigos de Dios en todo tiempo, y en todas las cosas y en todo lugar en que estuvieseis, aun hasta la muerte, para que seáis redimidos por Dios, y seáis contados con los de la primera resurrección, para que tengáis vida eterna;',
      },
    ],
    context:
      'Alma enseña el convenio bautismal: llevar cargas, consolar y ser testigos hasta la muerte.',
  },
  {
    id: 'mosiah-18-8-10',
    reference: 'Mosíah 18:8–10',
    text: 'Y aconteció que les dijo: He aquí las aguas de Mormón (porque así se llamaban); y ya que deseáis entrar en el redil de Dios y ser llamados su pueblo, y estáis dispuestos a llevar las cargas los unos de los otros para que sean ligeras; sí, y estáis dispuestos a llorar con los que lloran; sí, y a consolar a los que necesitan de consuelo, y ser testigos de Dios en todo tiempo, y en todas las cosas y en todo lugar en que estuvieseis, aun hasta la muerte, para que seáis redimidos por Dios, y seáis contados con los de la primera resurrección, para que tengáis vida eterna; os digo ahora, si este es el deseo de vuestros corazones, ¿qué os impide ser bautizados en el nombre del Señor, como testimonio ante él de que habéis concertado un convenio con él de que lo serviréis y guardaréis sus mandamientos, para que él derrame su Espíritu más abundantemente sobre vosotros?',
    verses: [
      { verse: 8, text: 'Y aconteció que les dijo: He aquí las aguas de Mormón (porque así se llamaban); y ya que deseáis entrar en el redil de Dios y ser llamados su pueblo, y estáis dispuestos a llevar las cargas los unos de los otros para que sean ligeras;' },
      { verse: 9, text: 'sí, y estáis dispuestos a llorar con los que lloran; sí, y a consolar a los que necesitan de consuelo, y ser testigos de Dios en todo tiempo, y en todas las cosas y en todo lugar en que estuvieseis, aun hasta la muerte, para que seáis redimidos por Dios, y seáis contados con los de la primera resurrección, para que tengáis vida eterna;' },
      { verse: 10, text: 'os digo ahora, si este es el deseo de vuestros corazones, ¿qué os impide ser bautizados en el nombre del Señor, como testimonio ante él de que habéis concertado un convenio con él de que lo serviréis y guardaréis sus mandamientos, para que él derrame su Espíritu más abundantemente sobre vosotros?' },
    ],
    context:
      'Alma describe el convenio del bautismo como compromiso con Cristo y con el servicio a los demás. No es solo un rito: es una vida.',
  },
  {
    id: '3-nephi-18-11',
    reference: '3 Nefi 18:11',
    text: 'Y siempre haréis esto por todos los que se arrepientan y se bauticen en mi nombre; y lo haréis en memoria de mi sangre, que he vertido por vosotros, para que testifiquéis al Padre que siempre os acordáis de mí. Y si os acordáis siempre de mí, tendréis mi Espíritu para que esté con vosotros.',
    verses: [
      { verse: 11, text: 'Y siempre haréis esto por todos los que se arrepientan y se bauticen en mi nombre; y lo haréis en memoria de mi sangre, que he vertido por vosotros, para que testifiquéis al Padre que siempre os acordáis de mí. Y si os acordáis siempre de mí, tendréis mi Espíritu para que esté con vosotros.' },
    ],
    context:
      'En Sus enseñanzas sobre la Santa Cena, Jesucristo afirma bendiciones asociadas a recordar, obedecer y renovar convenios.',
  },
  {
    id: 'dc-20-53-59',
    reference: 'Doctrina y Convenios 20:53–59',
    text: 'El deber del maestro es velar siempre por los miembros de la iglesia, y estar con ellos y fortalecerlos; y cuidar de que no haya iniquidad en la iglesia, ni aspereza entre uno y otro, ni mentiras, ni difamaciones, ni calumnias; y ver que los miembros de la iglesia se reúnan con frecuencia, y también ver que todos los miembros cumplan con sus deberes. Y se hará cargo de las reuniones si está ausente el élder o presbítero, y los diáconos le ayudarán siempre en todos sus deberes en la iglesia, si la ocasión lo requiere. Pero ni los maestros ni los diáconos tienen la autoridad para bautizar, administrar la santa cena, ni imponer las manos; deben, sin embargo, amonestar, exponer, exhortar, enseñar e invitar a todos a venir a Cristo.',
    verses: [
      { verse: 53, text: 'El deber del maestro es velar siempre por los miembros de la iglesia, y estar con ellos y fortalecerlos;' },
      { verse: 54, text: 'y cuidar de que no haya iniquidad en la iglesia, ni aspereza entre uno y otro, ni mentiras, ni difamaciones, ni calumnias;' },
      { verse: 55, text: 'y ver que los miembros de la iglesia se reúnan con frecuencia, y también ver que todos los miembros cumplan con sus deberes.' },
      { verse: 56, text: 'Y se hará cargo de las reuniones si está ausente el élder o presbítero,' },
      { verse: 57, text: 'y los diáconos le ayudarán siempre en todos sus deberes en la iglesia, si la ocasión lo requiere.' },
      { verse: 58, text: 'Pero ni los maestros ni los diáconos tienen la autoridad para bautizar, administrar la santa cena, ni imponer las manos;' },
      { verse: 59, text: 'deben, sin embargo, amonestar, exponer, exhortar, enseñar e invitar a todos a venir a Cristo.' },
    ],
    context:
      'Estos versículos describen deberes concretos del oficio de maestro: velar, fortalecer, preservar el orden espiritual y enseñar con fidelidad.',
  },
  {
    id: 'dc-107-86',
    reference: 'Doctrina y Convenios 107:86',
    text: 'Y también el deber del presidente del oficio de los maestros es presidir a veinticuatro maestros, y sentarse en concilio con ellos, enseñándoles los deberes de su oficio, cual se indican en los convenios.',
    verses: [
      { verse: 86, text: 'Y también el deber del presidente del oficio de los maestros es presidir a veinticuatro maestros, y sentarse en concilio con ellos, enseñándoles los deberes de su oficio, cual se indican en los convenios.' },
    ],
    context:
      'El Señor organiza el oficio de maestro con orden, consejo y enseñanza de deberes, no con improvisación.',
  },
  {
    id: 'moroni-6-4',
    reference: 'Moroni 6:4',
    text: 'Y después que habían sido recibidos por el bautismo, y el poder del Espíritu Santo había obrado en ellos y los había purificado, eran contados entre los del pueblo de la iglesia de Cristo; y se inscribían sus nombres, a fin de que se hiciese memoria de ellos y fuesen nutridos por la buena palabra de Dios, para guardarlos en la vía correcta, para conservarlos continuamente atentos a orar, confiando solamente en los méritos de Cristo, que era el autor y perfeccionador de su fe.',
    verses: [
      { verse: 4, text: 'Y después que habían sido recibidos por el bautismo, y el poder del Espíritu Santo había obrado en ellos y los había purificado, eran contados entre los del pueblo de la iglesia de Cristo; y se inscribían sus nombres, a fin de que se hiciese memoria de ellos y fuesen nutridos por la buena palabra de Dios, para guardarlos en la vía correcta, para conservarlos continuamente atentos a orar, confiando solamente en los méritos de Cristo, que era el autor y perfeccionador de su fe.' },
    ],
    context:
      'Moroni describe cómo la Iglesia cuida a los recién bautizados: recordarlos, nutrirlos y ayudarles a perseverar en Cristo.',
  },
  {
    id: 'galatians-6-1',
    reference: 'Gálatas 6:1',
    text: 'Hermanos, si alguno fuere sorprendido en alguna falta, vosotros que sois espirituales, restauradle con espíritu de mansedumbre, considerándote a ti mismo, no sea que tú también seas tentado.',
    verses: [
      { verse: 1, text: 'Hermanos, si alguno fuere sorprendido en alguna falta, vosotros que sois espirituales, restauradle con espíritu de mansedumbre, considerándote a ti mismo, no sea que tú también seas tentado.' },
    ],
    context:
      'Pablo enseña que la corrección cristiana debe hacerse con humildad, mansedumbre y conciencia de la propia fragilidad.',
  },
  {
    id: 'dc-121-41-42',
    reference: 'Doctrina y Convenios 121:41–42',
    text: 'Ningún poder o influencia se puede ni se debe mantener en virtud del sacerdocio, sino por persuasión, por longanimidad, benignidad, mansedumbre y por amor sincero; por bondad y por conocimiento puro, lo cual engrandecerá en gran manera el alma sin hipocresía y sin malicia;',
    verses: [
      { verse: 41, text: 'Ningún poder o influencia se puede ni se debe mantener en virtud del sacerdocio, sino por persuasión, por longanimidad, benignidad, mansedumbre y por amor sincero;' },
      { verse: 42, text: 'por bondad y por conocimiento puro, lo cual engrandecerá en gran manera el alma sin hipocresía y sin malicia;' },
    ],
    context:
      'Estos versículos definen la manera justa y santa de ejercer influencia: no con compulsión, sino con atributos semejantes a los de Cristo.',
  },
  {
    id: '1-corinthians-15-20-22',
    reference: '1 Corintios 15:20–22',
    text: 'Mas ahora Cristo ha resucitado de los muertos; primicias de los que durmieron es hecho. Porque por cuanto la muerte entró por un hombre, también por un hombre la resurrección de los muertos. Porque así como en Adán todos mueren, también en Cristo todos serán vivificados.',
    verses: [
      { verse: 20, text: 'Mas ahora Cristo ha resucitado de los muertos; primicias de los que durmieron es hecho.' },
      { verse: 21, text: 'Porque por cuanto la muerte entró por un hombre, también por un hombre la resurrección de los muertos.' },
      { verse: 22, text: 'Porque así como en Adán todos mueren, también en Cristo todos serán vivificados.' },
    ],
    context:
      'Pablo testifica que la resurrección de Cristo garantiza la resurrección de toda la humanidad. Es base doctrinal para esperanza frente a la muerte.',
  },
  {
    id: 'dc-20-75',
    reference: 'Doctrina y Convenios 20:75',
    text: 'Conviene que la iglesia se reúna a menudo para tomar el pan y el vino en memoria del Señor Jesús.',
    verses: [
      {
        verse: 75,
        text: 'Conviene que la iglesia se reúna a menudo para tomar el pan y el vino en memoria del Señor Jesús.',
      },
    ],
    context:
      'En esta revelación dada en abril de 1830, al organizarse formalmente la Iglesia restaurada, el Señor establece el patrón de reunirnos con frecuencia para participar de la Santa Cena en memoria de Jesucristo.',
  },
  {
    id: 'dc-20-79',
    reference: 'Doctrina y Convenios 20:79',
    text:
      'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo. Amén.',
    verses: [
      {
        verse: 79,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo. Amén.',
      },
    ],
    context:
      'Oración sacramental del agua revelada al profeta José Smith. Hoy se utiliza agua en lugar de vino, conforme a Doctrina y Convenios 27:2, pero el texto de la oración se conserva tal como fue revelado.',
  },
  {
    id: 'dc-27-2',
    reference: 'Doctrina y Convenios 27:2',
    text:
      'Porque he aquí, te digo que no importa lo que comáis o bebáis al tomar el sacramento, si es que lo hacéis con la mira puesta únicamente en mi gloria, recordando ante el Padre mi cuerpo que fue sacrificado por vosotros, y mi sangre que se derramó para la remisión de vuestros pecados.',
    verses: [
      {
        verse: 2,
        text: 'Porque he aquí, te digo que no importa lo que comáis o bebáis al tomar el sacramento, si es que lo hacéis con la mira puesta únicamente en mi gloria, recordando ante el Padre mi cuerpo que fue sacrificado por vosotros, y mi sangre que se derramó para la remisión de vuestros pecados.',
      },
    ],
    context:
      'Revelación de agosto de 1830, recibida cuando José Smith iba a procurar vino para la Santa Cena y un mensajero celestial lo detuvo. El Señor enseña que el poder del sacramento no reside en el elemento físico sino en la intención y el recuerdo de Su sacrificio. Es la base doctrinal del uso del agua en lugar de vino.',
  },
  {
    id: '3-nephi-18-7',
    reference: '3 Nefi 18:7',
    text:
      'Y será un testimonio al Padre de que siempre os acordáis de mí. Y si os acordáis siempre de mí, tendréis mi Espíritu para que esté con vosotros.',
    verses: [
      {
        verse: 7,
        text: 'Y será un testimonio al Padre de que siempre os acordáis de mí. Y si os acordáis siempre de mí, tendréis mi Espíritu para que esté con vosotros.',
      },
    ],
    context:
      'Palabras del Salvador resucitado al instituir el sacramento entre los nefitas. Une explícitamente el recordar a Cristo con la promesa de tener Su Espíritu, mostrando una relación directa entre memoria fiel y compañía espiritual.',
  },
  {
    id: 'moroni-4-3',
    reference: 'Moroni 4:3',
    text:
      'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén.',
    verses: [
      {
        verse: 3,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este pan para las almas de todos los que participen de él, para que lo coman en memoria del cuerpo de tu Hijo, y testifiquen ante ti, oh Dios, Padre Eterno, que están dispuestos a tomar sobre sí el nombre de tu Hijo, y a recordarle siempre, y a guardar sus mandamientos que él les ha dado, para que siempre puedan tener su Espíritu consigo. Amén.',
      },
    ],
    context:
      'Oración sacramental del pan tal como Moroni la registró en el Libro de Mormón. Es virtualmente idéntica a la oración revelada en Doctrina y Convenios 20:77, lo cual muestra continuidad doctrinal entre la Iglesia entre los nefitas y la Iglesia restaurada.',
  },
  {
    id: 'moroni-5-2',
    reference: 'Moroni 5:2',
    text:
      'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo.',
    verses: [
      {
        verse: 2,
        text: 'Oh Dios, Padre Eterno, en el nombre de Jesucristo, tu Hijo, te pedimos que bendigas y santifiques este vino para las almas de todos los que lo beban, para que lo hagan en memoria de la sangre de tu Hijo, que por ellos se derramó; para que testifiquen ante ti, oh Dios, Padre Eterno, que siempre se acuerdan de él, para que puedan tener su Espíritu consigo.',
      },
    ],
    context:
      'Oración sacramental del agua tal como Moroni la registró. Mantiene la misma estructura y promesa que la oración revelada modernamente en Doctrina y Convenios 20:79.',
  },
  {
    id: '3-nephi-9-20',
    reference: '3 Nefi 9:20',
    text:
      'Y me ofreceréis como sacrificio un corazón quebrantado y un espíritu contrito. Y al que venga a mí con un corazón quebrantado y un espíritu contrito, lo bautizaré con fuego y con el Espíritu Santo.',
    verses: [
      {
        verse: 20,
        text: 'Y me ofreceréis como sacrificio un corazón quebrantado y un espíritu contrito. Y al que venga a mí con un corazón quebrantado y un espíritu contrito, lo bautizaré con fuego y con el Espíritu Santo, así como los lamanitas fueron bautizados con fuego y con el Espíritu Santo al tiempo de su conversión, por motivo de su fe en mí, y no lo supieron.',
      },
    ],
    context:
      'El Salvador resucitado declara cuál es el sacrificio que ahora pide después de cumplir la ley de Moisés: ya no animales, sino un corazón quebrantado y un espíritu contrito. Esta es la disposición interior con la que llegamos al sacramento cada semana.',
  },
];
